/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Redeem_Tree_TitleInputs */

const en_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to redeem returning trees?`)
};

const ar_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف تستبدل الأشجار العائدة؟`)
};

const de_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie löst man wiederkehrende Bäume ein?`)
};

const es_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo canjear los árboles de regreso?`)
};

const fr_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment échanger les arbres de retour ?`)
};

const it_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come riscattare gli alberi di ritorno?`)
};

const ja_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復刻樹木の交換方法は？`)
};

const ko_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`돌아온 나무는 어떻게 교환하나요?`)
};

const pt_br_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como resgatar as árvores de volta?`)
};

const ru_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как обменять возвращающиеся деревья?`)
};

const th_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จะแลกรับต้นไม้ที่กลับมาได้อย่างไร?`)
};

const tr_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dönen ağaçlar nasıl alınır?`)
};

const zh_cn_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎么兑换返场树种？`)
};

const zh_tw_how_to_redeem_tree_title = /** @type {(inputs: How_To_Redeem_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎麼兌換回歸樹種？`)
};

/**
* | output |
* | --- |
* | "How to redeem returning trees?" |
*
* @param {How_To_Redeem_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_to_redeem_tree_title = /** @type {((inputs?: How_To_Redeem_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Redeem_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_to_redeem_tree_title(inputs)
	if (locale === "ar") return ar_how_to_redeem_tree_title(inputs)
	if (locale === "de") return de_how_to_redeem_tree_title(inputs)
	if (locale === "es") return es_how_to_redeem_tree_title(inputs)
	if (locale === "fr") return fr_how_to_redeem_tree_title(inputs)
	if (locale === "it") return it_how_to_redeem_tree_title(inputs)
	if (locale === "ja") return ja_how_to_redeem_tree_title(inputs)
	if (locale === "ko") return ko_how_to_redeem_tree_title(inputs)
	if (locale === "pt_br") return pt_br_how_to_redeem_tree_title(inputs)
	if (locale === "ru") return ru_how_to_redeem_tree_title(inputs)
	if (locale === "th") return th_how_to_redeem_tree_title(inputs)
	if (locale === "tr") return tr_how_to_redeem_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_how_to_redeem_tree_title(inputs)
	return zh_tw_how_to_redeem_tree_title(inputs)
});